// Tracking Hub (t.isprofit.com): funil comercial first-party do Laudando. Só etapas de funil vão para ele; uso do
// produto (laudos, modelos, assinaturas) fica exclusivamente no PostHog. A Meta recebe só o que o Tracking Hub
// encaminha (server-side, Conversions API); a compra (Purchase) vem do Payments Hub, nunca do navegador.
// Nunca envie e-mail, telefone, nome ou texto clínico aqui.
export const TRACKING_HUB_SITE_KEY = 'pk_e467d20b1fc20d76ca77ee53';

const FUNNEL = {
  pricing_viewed: 'ViewContent',
  plan_selected: 'plan_selected',
  checkout_started: 'InitiateCheckout',
  checkout_created: 'checkout_created',
  checkout_failed: 'checkout_failed',
  checkout_abandoned: 'checkout_cancelled',
  checkout_requires_login: 'checkout_requires_login',
  signup_completed: 'CompleteRegistration',
  trial_started: 'trial_started',
  subscription_portal_opened: 'subscription_portal_opened',
};

const ALLOWED_PROPS = ['plan_id', 'plan_tier', 'period', 'frequency', 'currency', 'event_id', 'auth_method', 'trial_days', 'stage'];

export const buildTrackingHubEvent = (event, properties = {}) => {
  const name = FUNNEL[event];
  if (!name) return null;
  const props = {};
  for (const key of ALLOWED_PROPS) {
    const value = properties[key];
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') props[key] = value;
  }
  if (Number.isFinite(properties.value)) props.value = properties.value;
  else if (Number.isFinite(properties.amount_cents)) props.value = properties.amount_cents / 100;
  return { name, props };
};

export const sendTrackingHubEvent = (event, properties = {}, w = typeof window === 'undefined' ? undefined : window) => {
  try {
    const built = buildTrackingHubEvent(event, properties);
    if (!built || !w || typeof w.th !== 'function') return;
    w.th(built.name, built.props);
  } catch {
    // Rastreamento nunca pode quebrar a tela.
  }
};

// Mesmo formato aceito pelo Payments Hub em POST /v1/checkouts (tracking_session).
export const isValidTrackingSession = (value) => typeof value === 'string' && /^[A-Za-z0-9_-]{8,128}$/.test(value);

export const readTrackingSession = (w = typeof window === 'undefined' ? undefined : window) => {
  try {
    const session = w?.th?.session?.();
    return isValidTrackingSession(session) ? session : undefined;
  } catch {
    return undefined;
  }
};
